<template>
  <b-modal
    v-model="ShowModal"
    id="modal-center"
    class="home-modal"
    size="md"
    no-close-on-backdrop="true"
    no-close-on-esc="true"
    centered
    hide-footer
    @close="handleOk"
  >
    <template v-slot:default>
      <div class="container">
        <div class="web-application-modal-slider"> 
            <div class="banner-item-insure">
                <a href="https://mtradeasia.com/insure/medical/travel-insurance-malaysia/main?utm_source=eRemit+website+banner_insure/medical/travel-insurance-malaysia&utm_medium=Banner&utm_campaign=eRemit+website+banner" target="_blank">
                    <img src="/static/commercial/loginbanner/insurance.jpg"/>
                </a>  
            </div>
        </div>
      </div>      
    </template>
  </b-modal>
</template>
<script>
export default {
  name: "AfterLoginInsureBanner",
  components: {
    
  },
  props: ["ShowModal"],

  data() {
    return {
      
    };
  },

  methods: {
    handleOk: function (evt) {
      this.ShowModal = false;
      this.$emit("okclicked", this.ShowModal);
      evt.preventDefault();
    },
  },
};
</script>
